import * as React from 'react';

// src/engines/flow/contextOpener.ts
var CONTEXT_KEY = /* @__PURE__ */ Symbol.for("@authe/tx-graph/GraphContextOpenerContext");
var GraphContextOpenerContext = globalThis[CONTEXT_KEY] ??= React.createContext(null);
function isPlainGraphClick(event) {
  return !event.defaultPrevented && event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;
}

export { GraphContextOpenerContext, isPlainGraphClick };
//# sourceMappingURL=context.js.map
//# sourceMappingURL=context.js.map